import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseX = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 28,
	height: 28,
	viewBox: "1 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(3, 2)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M17.9688 5.53125L5.03125 18.4688",
			stroke: "currentColor",
			strokeWidth: 1.4375,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M17.9688 18.4688L5.03125 5.53125",
			stroke: "currentColor",
			strokeWidth: 1.4375,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	})
});
export default SvgCloseX;
